module.exports = __webpack_public_path__ + "static/media/image-11.8f04f0b8.png";